/**
 * สุกรีเภสัช logomark (กากบาทเภสัช 2 สี: แกนตั้งฟ้า + แกนนอนเขียว ตามโลโก้จริง)
 * + ป้ายชื่อ "สุกรีเภสัช" (optional). ใช้เป็นไอคอนมาร์กเล็ก/watermark;
 * โลโก้เต็ม (มี wordmark) ใช้ไฟล์ /sukree-logo.png ในจุดแบรนด์ใหญ่.
 *
 *   <Logo />                          → mark only
 *   <Logo wordmark />                 → mark + "สุกรีเภสัช"
 *   <Logo white />                    → mark/text เป็นสีขาว (สำหรับพื้น gradient)
 *   <Logo wordmark sub="PayPilot" />  → เพิ่มป้ายผลิตภัณฑ์ใต้ชื่อ
 *   <Logo surface="dark" wordmark />  → เขียว/อ่อน สำหรับ sidebar ดำ (Luxury Ledger)
 *
 * ใช้ SVG inline (ไม่พึ่ง raster asset) → currentColor คุมสี M ได้ตามพื้น.
 */
interface Props {
  /** Tailwind height class for the mark, e.g. "h-8" (default). */
  size?: string;
  white?: boolean;
  wordmark?: boolean;
  /**
   * พื้นที่โลโก้วางอยู่. `'dark'` = เขียว/อ่อน ให้เห็นบน sidebar ดำ.
   */
  surface?: 'light' | 'dark';
  /** ป้ายผลิตภัณฑ์เล็กใต้ชื่อ. */
  sub?: string;
  className?: string;
}

export function Logo({ size = 'h-8', white = false, wordmark = false, surface = 'light', sub, className = '' }: Props) {
  const dark = surface === 'dark';
  // กากบาทเภสัช 2 สี: แกนนอนเขียว + แกนตั้งฟ้า. บนพื้น gradient (white) = ขาวล้วน.
  const hBar = white ? '#ffffff' : '#8CC63F';
  const vBar = white ? '#ffffff' : '#27AAE1';
  const wordColor = white ? 'text-white' : dark ? 'text-[#e0d9c8]' : 'text-ink';
  const subColor = white ? 'text-white/80' : dark ? 'text-[#8f877e]' : 'text-warm-gray';
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg viewBox="0 0 40 40" className={`${size} w-auto`} aria-label="สุกรีเภสัช" role="img">
        <rect x="4" y="15.5" width="32" height="9" rx="3" fill={hBar} />
        <rect x="15.5" y="4" width="9" height="32" rx="3" fill={vBar} />
      </svg>
      {wordmark && (
        <span className="leading-none">
          <span className={`font-display font-semibold text-lg ${wordColor}`}>สุกรีเภสัช</span>
          {sub && <span className={`block text-[10px] tracking-[.2em] uppercase mt-0.5 ${subColor}`}>{sub}</span>}
        </span>
      )}
    </span>
  );
}
